<template>
  <admin-layout
    :title="`Mapeamento de campos`"
    menu="Mapeamento de campos"
  >
    <h3>
      Entidades
    </h3>
    <div class="row">
      <div class="col-lg-12">
        <table class="table_jovool">
          <thead class="headerTable">
            <tr>
              <td>
                Nome
              </td>
              <td>
                Quantidade de campos
              </td>
              <td>

              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                Candidatos
              </td>
              <td>
                {{amount_candidate}}
              </td>
              <td>
                <inertia-link href="/recruiters/field_mapping_entities/candidates">
                  <div class="pointer">
                    <font-awesome-icon
                      class="color-grey"
                      icon="pencil-alt"
                    />
                  </div>
                </inertia-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </admin-layout>
</template>

<script>
export default {
  props: ["amount_candidate`"],
};
</script>
